import { render, staticRenderFns } from "./CardStatisticProfitChart.vue?vue&type=template&id=00349d48&"
import script from "./CardStatisticProfitChart.vue?vue&type=script&lang=js&"
export * from "./CardStatisticProfitChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports